var faq = document.getElementsByClassName("question");
var i;
for (i = 0; i < faq.length; i++) {
    faq[i].addEventListener("click", function () {

        let panel = this.nextElementSibling

//if panel is open, then this block will close it on mouse click

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            this.classList.remove('open')
        } else {

            //if panel is closed, then these codes will open it on mouse click & set those specific rules mentioned below.

            panel.style.maxHeight = panel.scrollHeight + 'px';
            this.classList.toggle('open')
        }
    });
}


var yolo = document.getElementsByClassName("nutrition");
var y;
for (y = 0; y < yolo.length; y++) {
    yolo[y].addEventListener("click", function () {

        let panel = this.nextElementSibling

//if panel is open, then this block will close it on mouse click

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
            this.classList.remove('open')
        } else {

            //if panel is closed, then these codes will open it on mouse click & set those specific rules mentioned below.

            panel.style.maxHeight = panel.scrollHeight + 'px';
            this.classList.toggle('open')
        }
    });
}



